export default __webpack_public_path__ + "static/media/statusConnect.188381ca.png";